import React from 'react';
import { Table } from 'rsuite';
import PropTypes from 'prop-types';

const { Cell } = Table;

const WeightCell = ({ rowData, dataKey, ...props }) => (
  <Cell {...props}>{parseFloat(rowData[dataKey])}</Cell>
);

WeightCell.propTypes = {
  dataKey: PropTypes.string.isRequired,
  rowData: PropTypes.shape({})
};

WeightCell.defaultProps = {
  rowData: null
};

export default WeightCell;
